import { useEffect, useState } from "react";
import "../../css/CashCollections.css";
import {useNavigate} from "react-router-dom";
import { fetchCashCollections, collectCashCollection } from "../../service/api/adminApi";



export default function CashCollections() {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [sortAmount, setSortAmount] = useState("");
    const [page, setPage] = useState(1);
    const [meta, setMeta] = useState({
        current_page: 1,
        last_page: 1,
        total: 0,
        from: 0,
        to: 0,
    });
    const [search, setSearch] = useState("");
    const [perPage, setPerPage] = useState(10);
    const [selected, setSelected] = useState(null);
    const [type, setType] = useState("FULL");
    const [customAmount, setCustomAmount] = useState("");
    const [message, setMessage] = useState("");

    const openProcess = (row) => {
        setSelected(row);
        setType("FULL");
        setCustomAmount("");
        setMessage("");
    };

    const closeModal = () => {
        setSelected(null);
        setType("FULL");
        setCustomAmount("");
        setMessage("");
    };
    const loadCollections = async () => {
        try {
            setLoading(true);

            const res = await fetchCashCollections({
                search,
                per_page: perPage,
                page,
                sort_amount: sortAmount,
            });

            const pagination = res?.meta || res || {};
            setRows(res?.data || []);
            setMeta({
                current_page: pagination.current_page || page,
                last_page: pagination.last_page || 1,
                total: pagination.total || 0,
                from: pagination.from || 0,
                to: pagination.to || 0,
            });
        } catch (error) {
            console.error(error);
            alert(error?.response?.data?.message || "Failed to load cash collections");
        } finally {
            setLoading(false);
        }
    };

    const resetFilters = () => {
        setSearch("");
        setPerPage(10);
        setPage(1);
        setSortAmount("");
    };

    useEffect(() => {
        loadCollections();
    }, [search, perPage, page, sortAmount]);
    const handleCollect = async (event) => {
        event.preventDefault();

        const pending = Number(selected?.amount || 0);
        const collectAmount = type === "FULL" ? pending : Number(customAmount || 0);

        if (pending <= 0) {
            alert("No cash in hand to collect.");
            return;
        }

        if (type === "CUSTOM" && (collectAmount <= 0 || collectAmount > pending)) {
            alert("Enter valid partial amount.");
            return;
        }

        try {
            await collectCashCollection({
                delivery_collection_id: selected.delivery_collection_id,
                type,
                custom_amount: type === "CUSTOM" ? collectAmount : null,
                message,
            });

            await loadCollections();
            closeModal();
        } catch (error) {
            console.error(error);
            alert(error?.response?.data?.message || "Failed to collect cash");
        }
    };
    const exportCsv = () => {
        const header = [
            "Delivery Guy Name",
            "Phone",
            "Cash in Hand",
            "Last Paid Date",
            "Last Active",
        ];

        const body = rows.map((row) => [
            row.name,
            row.phone,
            Number(row.amount || 0).toFixed(2),
            row.last_paid_date || "--",
            row.last_active_at || "--",
        ]);

        const csv = [header, ...body].map((row) => row.join(",")).join("\n");
        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `cash-collections-${new Date()
            .toISOString()
            .slice(0, 10)}.csv`;
        a.click();

        URL.revokeObjectURL(url);
    };
    return (
        <div className="cash-page">
            <div className="cash-head">
                <div>
                    <h2>Delivery Collection</h2>
                    <p>Manage delivery cash collections</p>
                </div>

                <button type="button" className="cash-reset-btn" onClick={resetFilters}>
                    Reset All Filters
                </button>
            </div>

            <div className="cash-card">
                <div className="cash-toolbar">
                    <input
                        className="cash-search"
                        type="text"
                        placeholder="Search with anything..."
                        value={search}
                        onChange={(event) => {
                            setSearch(event.target.value);
                            setPage(1);
                        }}
                    />

                    <div className="cash-toolbar-actions">
                        <select
                            className="cash-per-page"
                            value={sortAmount}
                            onChange={(event) => {
                                setSortAmount(event.target.value);
                                setPage(1);
                            }}
                        >
                            <option value="">Default</option>
                            <option value="high_to_low">Cash: High to Low</option>
                            <option value="low_to_high">Cash: Low to High</option>
                        </select>
                        <button type="button" className="cash-export-btn" onClick={exportCsv}>
                            Export as CSV
                        </button>

                        <select
                            className="cash-per-page"
                            value={perPage}
                            onChange={(event) => {
                                setPerPage(Number(event.target.value));
                                setPage(1);
                            }}
                        >
                            {[10, 25, 50, 100, 200, 500].map((value) => (
                                <option key={value} value={value}>
                                    {value}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="cash-table-wrap">
                    <table className="cash-table">
                        <thead>
                        <tr>
                            <th>Delivery Guy Name</th>
                            <th>Phone</th>
                            <th>Cash in Hand</th>
                            <th>Last Paid Date</th>
                            <th>Last Active</th>
                            <th className="cash-center">Action</th>
                        </tr>
                        </thead>

                        <tbody>
                        {rows.map((row) => (
                            <tr key={row.id}>
                                <td>
                                    <button type="button" className="cash-name-btn">
                                        {row.name}
                                    </button>
                                </td>
                                <td>{row.phone}</td>
                                <td>₹{Number(row.amount || 0).toFixed(2)}</td>
                                <td>{row.last_paid_date || "--"}</td>
                                <td>{row.last_active_at || "--"}</td>
                                <td className="cash-action-cell">
                                    <button
                                        type="button"
                                        className="cash-process-btn"
                                        onClick={() => openProcess(row)}
                                    >
                                        Process
                                    </button>

                                    <button
                                        type="button"
                                        className="cash-log-btn"
                                        onClick={() => navigate(`/finance/cash-collections/logs?user_id=${row.id}`)}
                                    >
                                        View Logs
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {loading && (
                            <tr>
                                <td colSpan="5" className="cash-empty">
                                    Loading...
                                </td>
                            </tr>
                        )}
                        {!loading && rows.length === 0 && (
                            <tr>
                                <td colSpan="5" className="cash-empty">
                                    No data found
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>

                <div className="cash-pagination">
          <span className="cash-pagination-summary">
            {meta.total > 0
                ? `Showing ${meta.from || (page - 1) * perPage + 1} to ${
                    meta.to || (page - 1) * perPage + rows.length
                } of ${meta.total} entries`
                : "Showing 0 entries"}
          </span>

                    <div className="cash-page-buttons">
                        <button
                            type="button"
                            className="cash-page-btn"
                            disabled={page <= 1 || loading}
                            onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                        >
                            Previous
                        </button>

                        <span className="cash-page-info">
              Page {meta.current_page || page} of {meta.last_page}
            </span>

                        <button
                            type="button"
                            className="cash-page-btn"
                            disabled={loading || page >= meta.last_page}
                            onClick={() =>
                                setPage((prev) => Math.min(prev + 1, meta.last_page))
                            }
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>

            {selected && (
                <div className="cash-modal-overlay" onMouseDown={closeModal}>
                    <div className="cash-modal" onMouseDown={(e) => e.stopPropagation()}>
                        <div className="cash-modal-head">
                            <div>
                                <h3>Name: {selected.name}</h3>
                                <p>
                                    Cash in Hand:{" "}
                                    <strong>₹{Number(selected.amount || 0).toFixed(2)}</strong>
                                </p>
                            </div>

                            <button type="button" onClick={closeModal}>
                                ×
                            </button>
                        </div>

                        <form onSubmit={handleCollect}>
                            <div className="cash-form-row">
                                <label>Collection Type</label>
                                <select value={type} onChange={(e) => setType(e.target.value)}>
                                    <option value="FULL">Full Amount</option>
                                    <option value="CUSTOM">Partial Amount</option>
                                </select>
                            </div>

                            {type === "CUSTOM" && (
                                <div className="cash-form-row">
                                    <label>Amount</label>
                                    <input
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        value={customAmount}
                                        onChange={(e) => setCustomAmount(e.target.value)}
                                        placeholder="Enter the amount in ₹"
                                        required
                                    />
                                </div>
                            )}

                            <div className="cash-form-row">
                                <label>Message</label>
                                <input
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    placeholder="Message or Description"
                                />
                            </div>

                            <div className="cash-modal-actions">
                                <button
                                    type="button"
                                    className="cash-cancel-btn"
                                    onClick={closeModal}
                                >
                                    Cancel
                                </button>

                                <button type="submit" className="cash-submit-btn">
                                    Collect
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}